import React, { useState,useEffect } from "react";
import Modal from "./components/Modal.jsx";
import ProfileSection from "./components/ProfileSection.jsx";
import HashtagSection from "./components/HashtagSection.jsx";
import GraphLayout from "./components/GraphLayout.jsx";
import RelationshipGraph from "./components/RelationshipGraph.jsx";
import { Layers, Hash } from "lucide-react";
import axios from "axios";

function App() {
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [selectedProfiles, setSelectedProfiles] = useState([]);
  const [selectedHashtags, setSelectedHashtags] = useState([]);
  const [showGraph, setShowGraph] = useState(false);
  const [selectedLayout, setSelectedLayout] = useState("tree");
  const [relationType, setRelationType] = useState("direct");
  const [activeTab, setActiveTab] = useState("profiles");
  const [maxNodes, setMaxNodes] = useState(5);
  const [selectedPlatform, setSelectedPlatform] = useState(null);
  const [graphData, setGraphData] = useState([]); // State to store graph data
  const [allProfileData, setAllProfileData] = useState(null); 
  // const [responseData, setResponseData] = useState(null); // State to store API response data

  const platforms = [
    "facebook",
    "twitter",
    "instagram",
    "tikTok",
    // Add other platform names here as needed
  ];

  const handleSearch = async () => {
    // Validation for mutual relation type with fewer than 2 hashtags
    if (
      activeTab === "hashtags" &&
      relationType === "mutual" &&
      selectedHashtags.length < 2
    ) {
      return; // Prevent search if condition is not met
    }
  
    setIsModalOpen(false); // Close modal
    setShowGraph(true); // Show graph
  
    // Prepare the payload based on the selected data
    const hashtags = activeTab === "hashtags" ? selectedHashtags : []; // Send all selected hashtags in mutual relation
    const directHashtags = activeTab === "hashtags" ? selectedHashtags : []; // For direct, use hashtags as key

    const payload = {
      platform: selectedPlatform, // Use selected platform
      [relationType === "direct" ? 'hashtag' : 'hashtags']: relationType === "direct" ? directHashtags : hashtags, // Use 'hashtag' for direct relation and 'hashtags' for mutual relation
    };
    console.log("Payload:", payload); // Log payload for debugging
  
    try {
      // Send API request based on relation type (direct or mutual)
      const response = await axios.post(
        relationType === "direct"
          ? `api/direct/hashtag`
          : `api/mutual/hashtag`,
        payload
      );
  
      console.log("Response from API:", response.data);
  
      // Ensure response.data is in the correct format (array of platform data)
      if (response.data && Array.isArray(response.data)) {
        // Filter platform data matching the selected platform
        const platformData = response.data.filter(
          (data) => data.name.toLowerCase() === selectedPlatform.toLowerCase()
        );
  
        if (platformData.length > 0) {
          // Aggregate profiles for the selected platform
          const profiles = platformData.flatMap((platform) => platform.profiles || []);
          console.log("All Profiles for platform:", profiles);
  
          // Build graph data based on active tab (profiles or hashtags)
          const newGraphData =
            activeTab === "profiles"
              ? selectedProfiles
              : hashtags.map((hashtag) => ({
                  id: hashtag,
                  label: hashtag,
                  type: "hashtag",
                  profiles: profiles, // Use aggregated profiles
                }));
          console.log("Graph Data:", newGraphData);
  
          setGraphData(newGraphData); // Update graph data
        } else {
          console.error(`No profile data found for ${selectedPlatform}`);
        }
      } else {
        console.error("Invalid response format. Expected an array of platform data.");
      }
    } catch (error) {
      console.error("Error sending data:", error); // Handle any errors during the API request
    }
};

  
  const fetchallProfile = async () => {
    try {
      const response = await axios.get('api/all/profiles/data');
      console.log("All Profile Data:", response.data);
      setAllProfileData(response.data); // Store in state
    } catch (error) {
      console.error("Error fetching Instagram profile:", error);
    }
  };

  useEffect(() => {
    fetchallProfile(); // Fetch data when component mounts
  }, []);
 


 



  

  const handlePlatformChange = (platform) => {
    setSelectedPlatform(platform);
    setSelectedHashtags([]);
    setSelectedProfiles([]);
  };

  const handleRelationTypeChange = (type) => {
    setRelationType(type);
    setSelectedHashtags([]);
    setSelectedProfiles([]);
  };

  const canSearch = selectedProfiles.length > 0 || selectedHashtags.length > 0;

  const TabButton = ({ id, icon: Icon, label }) => (
    <button
      onClick={() => setActiveTab(id)}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "0.5rem",
        padding: "0.75rem 1.5rem",
        color: activeTab === id ? "#65ccb7" : "#6b7280",
        border: "none",
        background: "none",
        fontWeight: "500",
        cursor: "pointer",
        borderBottom: activeTab === id ? "2px solid #65ccb7" : "none",
      }}
    >
      <Icon style={{ width: "1.25rem", height: "1.25rem" }} />
      <span style={{ fontSize: "16px" }}>{label}</span>
    </button>
  );

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        zIndex: "100",
      }}
    >
      {!showGraph ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
          }}
        >
        
        </div>
      ) : (
        <div
          style={{
            padding: "1.5rem",
            backgroundColor: "#ffffff",
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
            borderRadius: "1rem",
            marginLeft: "280px",
            marginRight: "10px",
            marginTop: "10px",
            zIndex: "1",
          }}
        >
          <GraphLayout
            selectedLayout={selectedLayout}
            onLayoutSelect={setSelectedLayout}
            onOpenTargets={() => setIsModalOpen(true)}
            maxNodes={maxNodes}
            onMaxNodesChange={setMaxNodes}
          />
          
          <RelationshipGraph
            data={activeTab === "profiles" ? selectedProfiles : graphData}
            layout={selectedLayout}
            relationType={relationType}
            maxNodes={maxNodes}
            platform={selectedPlatform}
          />
        </div>
      )}

      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "0",
              borderBottom: "1px solid #e5e7eb",
              backgroundColor: "#ffffff",
              alignSelf:"center"
            }}
          >
                <TabButton id="hashtags" icon={Hash} label="Hashtags" />
            <TabButton id="profiles" icon={Layers} label="Profiles" />
        
          </div>

          <div style={{ flex: 1, overflow: "hidden", padding: "1.5rem" }}>
            {activeTab === "profiles" ? (
              <ProfileSection
                data={allProfileData}
                selectedProfiles={selectedProfiles}
                onProfileSelect={setSelectedProfiles}
                onProfileRemove={setSelectedProfiles}
                relationType={relationType}
                onRelationTypeChange={handleRelationTypeChange}
                selectedPlatform={selectedPlatform}
                onPlatformChange={handlePlatformChange}
              />
            ) : (
              <HashtagSection
                hashtags={[
                  "paf",
                  "iaf",
                  "india",
                  "balochistan",
                  "bla",
                ]}
                selectedHashtags={selectedHashtags}
                onHashtagSelect={setSelectedHashtags}
                onHashtagRemove={(hashtag) =>
                  setSelectedHashtags(
                    selectedHashtags.filter((h) => h !== hashtag)
                  )
                }
                selectedPlatform={selectedPlatform}
                onPlatformChange={handlePlatformChange}
                platforms={platforms}
                relationType={relationType}
                onRelationTypeChange={handleRelationTypeChange}
              />

            )}
          </div>

          <div
            style={{
              padding: "1rem",
              backgroundColor: "#f9fafb",
              borderTop: "1px solid #e5e7eb",
            }}
          >
            <button
              onClick={handleSearch}
              disabled={!canSearch}
              style={{
                width: "100%",
                padding: "0.625rem",
                borderRadius: "0.5rem",
                fontWeight: "800",
                backgroundColor: canSearch ? "#65ccb7" : "#f9fafb",
                color: canSearch ? "white" : "#6b7280",
                cursor: canSearch ? "pointer" : "not-allowed",
                opacity: canSearch ? 1 : 0.6,
                transition: "opacity 0.2s",
                border: "none",
              }}
            >
              Search
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default App;
